import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';
import { type BlazeSchema } from '@blaze-shared/schema-domain';

import { type DefinitionMapper } from '../../../ai';
import { type CanvasElementDefinition } from '../../../canvas-elements/element-definition';

import { type AvailabilityDefinition } from './availability.definition';

export class AvailabilityDefinitionMapper implements DefinitionMapper<'availability'> {
  readonly type = 'availability';

  extract(
    _element: CanvasElementFrom<'availability'>,
    _schemas: Readonly<Record<string, BlazeSchema>>,
    _definition: CanvasElementDefinition<'availability'>,
  ): PartialDeep<AvailabilityDefinition> {
    return {};
  }
}
